import classNames from 'classnames';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';

export const getInputStyle = (errorMsg, isGrayField = false) => {
  return classNames(
    ` w-full
      px-3
      py-1.5
      text-[15px]
      h-[50px]
      font-normal
      text-gray-700
       bg-clip-padding
      border 
      rounded
      transition
      ease-in-out
      mx-0
      mb-0
      rounded-[5px]
      focus:outline-none`,
    { 'border-zinc-200 bg-white': !errorMsg && !isGrayField },
    { 'border-field-gray-border bg-field-gray': !errorMsg && isGrayField },
    { 'border-error': errorMsg },
  );
};

const StyledTextField = styled.div`
  ${(props) => props.customStyles}
  ${(props) => props.defaultStyles}
`;

export default function TextField({
  name,
  id,
  onChange,
  onBlur,
  customStyles,
  setFormErrorMessages,
  value = '',
  label = '',
  type = 'text',
  placeholder = '',
  errorMessage = '',
  isRequired = false,
  isVisible = true,
  labelCssClass = '',
  disabled = false,
}) {
  const { whiteLabelSettings: { secondaryColourDarker } = {} } =
    useWhiteLabelSettings();
  const [fieldId, setFieldId] = useState();

  useEffect(() => {
    setFieldId(id || uuid());
  }, [id]);

  const onChangeHandler = (event = {}) => {
    onChange?.(event);
  };

  const onBlurHandler = (event = {}) => {
    onBlur?.(event);
    const REQUIRED_FIELD_ERROR_MSG = `${label || 'This field'} is required.`;
    const { target = {} } = event;
    const { name: fieldName, value: fieldValue } = target;

    if (isRequired) {
      if (`${fieldValue}`.trim().length < 1) {
        setFormErrorMessages?.(fieldName, REQUIRED_FIELD_ERROR_MSG);
        return;
      }

      setFormErrorMessages?.(fieldName, '');
    }
  };

  const defaultStyles = `
    input:focus {
      border-color: ${secondaryColourDarker};
    }
    margin: .5rem 0;
    width: 100%;
    line-height: 20px;
  `;

  const disabledStyles = `
    input:disabled {
      background-color: #e5e7eb;
      color: #9ca3af;
      cursor: not-allowed;
      border-color: #d1d5db;
      pointer-events: none;
    }
  `;

  if (!isVisible) {
    return null;
  }

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <StyledTextField
      customStyles={`${customStyles} ${disabledStyles}`}
      defaultStyles={defaultStyles}
    >
      <label
        className={`block text-gray-500 my-1 text-[16px] ${labelCssClass}`}
        htmlFor={fieldId}
      >
        {label}
      </label>
      <input
        required={isRequired}
        type={type}
        id={fieldId}
        name={name}
        className={getInputStyle(errorMessage)}
        placeholder={placeholder}
        value={value}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        disabled={disabled}
      />
      {errorMessage && (
        <div className="text-error mt-1 text-[0.8rem]">{errorMessage}</div>
      )}
    </StyledTextField>
  );
}
